/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".full-image[_ngcontent-%COMP%]   .image-container[_ngcontent-%COMP%]   .img-thumbnail[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{max-width:100%;height:auto;max-height:100%}"];
export { styles as styles };
